import type { Article, LText } from "@/mocks/articles";

const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://usfanssheet.wtf").replace(/\/$/, "");
const SITE_NAME = "US Fans Spreadsheet";
const SITE_LOGO =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

function JsonLd({ data }: { data: Record<string, unknown> }) {
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />
  );
}

export function SiteSchema() {
  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: SITE_NAME,
          url: `${SITE_URL}/`,
          logo: SITE_LOGO,
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: SITE_NAME,
          url: `${SITE_URL}/`,
        }}
      />
    </>
  );
}

export function ArticleSchema({ article, lang }: { article: Article; lang: keyof LText }) {
  const text = (o: LText) => o[lang] || o.en;
  const path =
    article.slug === "usfans-spreadsheet-guide"
      ? "/usfans-spreadsheet-guide"
      : `/article/${article.slug}`;
  const url = `${SITE_URL}${path}`;

  return (
    <>
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: text(article.title),
          description: text(article.excerpt),
          image: article.image,
          author: { "@type": "Organization", name: SITE_NAME, url: `${SITE_URL}/` },
          publisher: { "@type": "Organization", name: SITE_NAME, logo: SITE_LOGO },
          mainEntityOfPage: url,
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: article.faqs.map((f) => ({
            "@type": "Question",
            name: text(f.q),
            acceptedAnswer: { "@type": "Answer", text: text(f.a) },
          })),
        }}
      />
    </>
  );
}